import BookCard from '../cards/BookCard'
import BookList from '../lists/BookList'
import BookModal from '../modals/BookModal'
import CodeNotebookCard from '../cards/CodeNotebookCard'
import CodeNotebookList from '../lists/CodeNotebookList'
import CodeNotebookModal from '../modals/CodeNotebookModal'
import CourseCard from '../cards/CourseCard'
import CourseList from '../lists/CourseList'
import CourseModal from '../modals/CourseModal'
import PaperCard from '../cards/PaperCard'
import PaperList from '../lists/PaperList'
import PaperModal from '../modals/PaperModal'
import PodcastCard from '../cards/PodcastCard'
import PodcastList from '../lists/PodcastList'
import PodcastModal from '../modals/PodcastModal'
import VideoCard from '../cards/VideoCard'
import VideoList from '../lists/VideoList'
import VideoModal from '../modals/VideoModal'

import { initializeBooks, searchBooks } from '../../reducers/booksReducer'
import { initializeCodeNotebooks, searchCodeNotebooks } from '../../reducers/codenotebooksReducer'
import { initializeCourses, searchCourses } from '../../reducers/coursesReducer'
import { initializePapers, searchPapers } from '../../reducers/papersReducer'
import { initializePodcasts, searchPodcasts } from '../../reducers/podcastsReducer'
import { initializeVideos, searchVideos } from '../../reducers/videosReducer'

import { PAGES } from '../navigation/routes'

// One entry per simple resource browse page. Each becomes a pair of routes
// (list + /:id deep link) rendered by ResourceSearchPage in App.js.
// Policies stays a standalone page: its sorting and tag URL params differ.
const RESOURCE_SEARCH_PAGES = [
    {
        page: PAGES.books,
        stateKey: 'books',
        initializeAction: initializeBooks,
        searchAction: searchBooks,
        CardComponent: BookCard,
        ListComponent: BookList,
        ModalComponent: BookModal,
    },
    {
        page: PAGES.courses,
        stateKey: 'courses',
        initializeAction: initializeCourses,
        searchAction: searchCourses,
        CardComponent: CourseCard,
        ListComponent: CourseList,
        ModalComponent: CourseModal,
    },
    {
        page: PAGES.papers,
        stateKey: 'papers',
        initializeAction: initializePapers,
        searchAction: searchPapers,
        CardComponent: PaperCard,
        ListComponent: PaperList,
        ModalComponent: PaperModal,
    },
    {
        page: PAGES.podcasts,
        stateKey: 'podcasts',
        initializeAction: initializePodcasts,
        searchAction: searchPodcasts,
        CardComponent: PodcastCard,
        ListComponent: PodcastList,
        ModalComponent: PodcastModal,
    },
    {
        page: PAGES.videos,
        stateKey: 'videos',
        initializeAction: initializeVideos,
        searchAction: searchVideos,
        CardComponent: VideoCard,
        ListComponent: VideoList,
        ModalComponent: VideoModal,
    },
    {
        page: PAGES.codenotebooks,
        stateKey: 'codenotebooks',
        initializeAction: initializeCodeNotebooks,
        searchAction: searchCodeNotebooks,
        CardComponent: CodeNotebookCard,
        ListComponent: CodeNotebookList,
        ModalComponent: CodeNotebookModal,
    },
]

export default RESOURCE_SEARCH_PAGES
